import styled from 'styled-components';

export const AuditEntryIcon = styled.div<{
  auditEntryType: 'case' | 'report';
}>`
  height: 48px;
  width: 48px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.auditEntryType === 'case'
      ? props.theme.atlas.semantic.color.action.primary.default
      : props.theme.atlas.semantic.color.type.default};
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 25px 0 10px;

  &::before {
    content: '';
    border-left: 1px solid black;
    position: relative;
    z-index: 10;
    height: 110%;
    margin-bottom: 110px;
    margin-right: -12px;
  }

  &::after {
    content: '';
    border-left: 1px solid black;
    z-index: 10;
    position: relative;
    margin-left: -1px;
    height: 110%;
    margin-top: 110px;
    margin-left: -13px;
  }
`;

export const AuditEntryDetailsContainer = styled.div<{
  auditEntryType: 'case' | 'report';
}>`
  background-color: ${(props) =>
    props.auditEntryType === 'case'
      ? props.theme.atlas.semantic.color.surface.variant
      : props.theme.atlas.semantic.color.surface.default};
  border: 2px solid ${({ theme }) => theme.atlas.semantic.color.surface.variant};
  border-radius: 8px;
  padding: 5px 20px;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  width: 500px;
`;

export const AuditEntryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
`;

export const AuditEntryDetail = styled.p`
  font-size: 16px;
  font-weight: 700;
  margin-top: 10px;
  word-break: break-word;
`;

export const AuditEntryContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 20px auto;
  justify-content: center;

  &:first-child > div::before {
    border: none;
  }

  &:first-child > div::after {
    margin-right: -1px;
  }

  &:last-child > div::before {
    margin-left: -1px;
  }

  &:last-child > div::after {
    border: none;
  }
`;
